import React, { createRef } from 'react';
import Translator from '../../../core/i18n';
import { Log } from 'ng2-logger';
import CourseContentWeeksActivities from '../course-content-week-activities/main';
import { IAppState, IAction } from '../../../models/action/core';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../store/actions/coursePage';
import { Common } from '../../../core/common';
import { string } from 'prop-types';
import Loading from '../../loading/loading';
import ICourseContentMenu from '../../../models/components/course-content-menu';
import { CourseContentMenuType } from '../../../models/enums/CourseContentMenuType';
import { Redirect } from 'react-router';
import Moment from 'moment';
import { UserType } from '../../../models/enums/userType';
import ContentLoader from 'react-content-loader';
import HeaderOptionss from '../../../pages/main-navigation/header-optionss';
import { IActivityCard } from '../../../models/components/activity-card';
import queryString from 'querystring';
import ProgressCircleLargeSidebar from '../../progress-circle/progress-circle-large-sidebar';
import { Badge } from 'react-bootstrap';
import { getCourseContentsWeekActivitiesAction } from '../../../store/actions/coursePage';
import { CourseDefaultViewType } from '../../../models/enums/CourseDefaultViewType';
import ReactGA from 'react-ga4';
import { enrollmentStatus } from '../../../models/enums/enrollmentStatus';
import ProgressPercent from '../course-content-selection-vertical-menu/progressPercent';
import { Modal, ModalBody } from 'reactstrap';
import AddActivityButton from '../../add-activity-button/main';
import Tooltip from '../../tooltip/main';

const T = Translator.create();
const _logger = Log.create('course-content-weeks');
const token: any = localStorage.getItem('access_token');
let _common: Common;

class CourseContentWeeks extends React.Component<ICourseContentMenu> {
    public state = {
        actviteContextId: string,
        redirect: false,
        loaded: false,
        selectedHeaderId: '',
        scrollHeaderId: '',
        enableScroll: true,
        activeCollapse: undefined,
        weeklyTerm: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 1,
        activeWeek: '0',
        isFirstLoad: true,
        filters: {
            searchedText: '',
            selectedActivityTypes: [],
            sort: this.props.sort ?? '-',
            hasFilter: false,
            GetOnlyPassiveList: false,
        },
        isActiveWeek: true,
        isCollapseOpen: false,
        handleByManuel: false,
        modalStatus: false,
        listViewCalled: false
    };

    collapseRef;

    constructor(props: any) {
        super(props);
        _common = new Common();
        this.collapseRef = createRef<HTMLDivElement>();
    }

    componentDidMount() {
        document.getElementById('activities-tab')!.addEventListener('scroll', this.trackScrolling);
        if (!this.props.courseContentMenuType) {
            this.props.dispatch(Actions.getCourseContentMenu(this.props.coursePageClassId!, this.props.coursePageActivityId ?? "", this.props.weekOrUnitId ?? "0", false, "getCourseContentMenu", "get"))

        }
        if (!this.state.loaded) {
            this.setState({ loaded: true, isFirstLoad: true, isActiveWeek: true });
            if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 0) {
                this.SetActiveMenu(this.props);

            }
        }
        if (!this.props.courseDefaultView && this.props.coursePageclassInformation && (this.props.coursePageclassInformation.courseDefaultView || this.props.coursePageclassInformation.courseDefaultView === CourseDefaultViewType.Card)) {
            this.props.dispatch(Actions.setCourseDefaultView(this.props.coursePageclassInformation.courseDefaultView))
        }
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 0) {
            if (!this.props.courseContentTermWeeks[0].notWeekly) {
                this.setState({ weeklyTerm: true })

            } else {
                this.setState({ weeklyTerm: false })
            }
        }
        this.setState({ enableScroll: true })

    }

    callSetActiveMenu = (disableFilter?: boolean | null) => {
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 0) {

            if (disableFilter === true) {
                this.SetActiveMenu(this.props, false);

            }
            else {
                this.SetActiveMenu(this.props);
            }

        }
    }

    componentDidUpdate(prevProps: Readonly<ICourseContentMenu>, prevState: Readonly<any>, snapshot?: any): void {

        if (!this.state.loaded && this.state.loaded !== prevState.loaded) {
            this.setState({ loaded: true });
            this.callSetActiveMenu()
        }

        if (this.props.courseDefaultView !== prevProps.courseDefaultView && this.props.courseDefaultView === CourseDefaultViewType.Card && prevProps.courseDefaultView === CourseDefaultViewType.List) {
            this.showActiveWeek();

        }

        if (this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks && this.props.coursePageClassId !== prevProps.coursePageClassId) {
            if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 0) {
                this.setState({ weeklyTerm: !this.props.courseContentTermWeeks[0].notWeekly })
            }
        }

        if (this.props.coursePageClassId !== prevProps.coursePageClassId && this.state.enableScroll) {
            this.callSetActiveMenu(true);
        }



        if (this.props.modalVisible == prevProps.modalVisible) {
            this.scrollOnFirstLoad()

        }

        this.handleCollapse(prevState);

        if (this.props.courseDefaultView !== prevProps.courseDefaultView && this.props.courseDefaultView === CourseDefaultViewType.List) {
          
            this.scrollToWeek(this.state.activeWeek ? this.state.activeWeek : '0')

        }    

    }

    showActiveWeek = () => {
        let collapsedWeek = this.props.courseContentTermWeeks!.find(x => x.termWeekId === (this.state.activeCollapse ? this.state.activeCollapse : '0'));
        const itemGuid = collapsedWeek?.itemGuid ? collapsedWeek.itemGuid : '';
        if (itemGuid) {
            const element = document.getElementById("collapse" + itemGuid);

            if (element) {
                if (!element.classList.contains("show")) {
                    element.classList.add("show")
                    this.setState({ activeCollapse: collapsedWeek?.termWeekId, isCollapseOpen: true })
                }
            }
            this.checkActivitiesAndWeeksUpToDate()
        }
    }

    scrollOnFirstLoad = () => {
        if (this.state.activeWeek && this.state.activeWeek !== '0') {
            const checkInterval = setInterval(() => {
                const activitiesHeaderElement = document.getElementById('activitiesHeader' + this.state.activeWeek);
                const activitiesContent = document.getElementById('spinnerIdWeekA_Content')
                let activitiesDisplayProp;
                if (activitiesContent) {
                    activitiesDisplayProp = activitiesContent.style.display;
                }

                if (activitiesHeaderElement) {
                    if (this.state.isFirstLoad && activitiesDisplayProp && activitiesDisplayProp === 'block') {
                        this.scrollToWeek(this.state.activeWeek);
                        this.setState({ isFirstLoad: false })
                    }

                    clearInterval(checkInterval);
                }
            }, 1000);
        }
    }

    checkActivitiesAndWeeksUpToDate = () => {
        if (this.state.activeCollapse !== this.props.weekOrUnitId) {
            this.props.dispatch(getCourseContentsWeekActivitiesAction(
                this.props.coursePageClassId ? this.props.coursePageClassId : '0',
                this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
                this.state.activeCollapse !== '0',
                0,
                1000,
                this.state.activeCollapse === '0' ? '-1' : this.state.activeCollapse!,
                false,
                this.state.activeCollapse === '0',
                null,
                'contentWeekActivities',
                'get', true, this.props.sort ?? "-"));

            this.triggerActivityList(this.state.activeCollapse)

        }
        else if (!this.state.isActiveWeek) {

            this.triggerActivityList(this.props.weekOrUnitId)
        }
    }

    public componentWillUnmount = () => {
        this.setState({ listViewCalled: false });
        document.getElementById('activities-tab')!.removeEventListener('scroll', this.trackScrolling);
        this.props.dispatch(Actions.getCourseContentMenu(this.props.coursePageClassId!, this.props.coursePageActivityId ?? "", this.props.weekOrUnitId ?? "0", true, "getCourseContentMenu", "get"))

    }

    triggerActivityList = (weekId: any) => {
        const param: IActivityCard = {
            actId: '',
            coursePageClassId: this.props.coursePageClassId,
            coursePageActivityId: this.props.coursePageActivityId,
            courseContentTermWeeks: this.props.courseContentTermWeeks,
            hasFilter: false,
            activityFilters: this.state.filters,
            GetOnlyPassiveList: false,
            weekOrUnitId: weekId === '0' ? '-1' : weekId,
            courseContentMenuType: this.props.courseContentMenuType,
            courseContentWeekActivities: this.props.courseContentWeeksActivities,
            sort: this.props.sort!
        };
        this.props.dispatch(Actions.SetTriggerGetActivities(param, undefined, "SetTriggerGetActivities", 'get', this.props.courseDefaultView, false));
    }

    trackScrolling = () => {
        const goTop = document.getElementById('go-top');
        const activitiesTab = document.getElementById('activities-tab');

        if (goTop && activitiesTab && (this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory || this.props.courseContentMenuType === CourseContentMenuType.week)) {
            if (activitiesTab.scrollTop > 600) {
                goTop.className = 'gotopbtn animated fadeIn';
            } else {
                goTop.className = 'gotopbtn animated fadeOut';
            }
        }

        const els = document.getElementsByClassName('header-scroll');
        const arrayHeaders = [];

        for (let i = 0; i < els.length; i++) {
            arrayHeaders.push({ top: els[i].getBoundingClientRect().top - 283, Id: els[i].id.replace('activitiesHeader', ''), proximity: Math.abs(0 - (els[i].getBoundingClientRect().top - 283)) });
        }

        if (arrayHeaders.length > 0) {
            const currentDivElement = arrayHeaders.filter(f => f.top < 100).sort((a, b) => a.proximity - b.proximity)[0];
            if (currentDivElement) {
                if (this.state.scrollHeaderId !== currentDivElement.Id) {
                    this.setState({ scrollHeaderId: currentDivElement.Id });
                }
            }
        }
    };

    public SetActiveMenu = (props: ICourseContentMenu, hasFilter?: boolean, isByPassActivityList: boolean = false) => {
        let weekOrUnitId: string | null | undefined = '0';

        if (props.weekOrUnitId) {
            weekOrUnitId = this.props.weekOrUnitId;
            this.checkWeekDates(this.props.weekOrUnitId)
            this.setState({ activeWeek: this.props.weekOrUnitId });
        }
        else {
            weekOrUnitId = this.state.weeklyTerm ? this.findActiveWeek() : "0";
        }

        if (props.courseContentMenuType === CourseContentMenuType.weekAndActivity || props.courseContentMenuType === CourseContentMenuType.week || props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory) {

            if (hasFilter === false) {
                this.weekOnClick(undefined, '', weekOrUnitId!, props.courseContentMenuType, true, true);
            }
            else {
                this.weekOnClick(undefined, '', weekOrUnitId!, props.courseContentMenuType, true);
            }
        }
    }

    findActiveWeek = () => {
        const nowDate = new Date().toISOString();
        let week = this.props.courseContentTermWeeks?.find((x: any) => x.startDate && x.endDate && x.startDate.toString() <= nowDate && nowDate <= x.endDate.toString());

        if (week?.termWeekId) {

            this.checkWeekDates(week.termWeekId)
            this.setState({ activeWeek: week.termWeekId });
            return week.termWeekId;
        }
        else {
            return "0";
        }
    }

    checkWeekDates = (weekId: any) => {
        const week = this.props.courseContentTermWeeks?.find(x => x.termWeekId === weekId);
        const nowDate = new Date().toISOString();

        if (week?.startDate && week?.endDate) {
            if (!(week.startDate.toString() <= nowDate && nowDate <= week.endDate.toString())) {

                this.setState({ isActiveWeek: false })
            }
        }
    }

    scrollToWeek = (weekid: any) => {

        const itemPosition = document.getElementById('activitiesHeader' + weekid);
        const getScrollElement = document.getElementById('activities-tab');

        let mobileBlank = 10;
        if (this.props.showMobile) {
            mobileBlank = 100;
        }

        if (itemPosition && getScrollElement && itemPosition.offsetTop) {
            getScrollElement.scrollTop = itemPosition.offsetTop - mobileBlank;
        }

    }

    public getUiMonth = (startDate: Date, endDate: Date): string => {
        const getStartDay = new Date(startDate).getDate().toString();
        const getEndDay = new Date(endDate).getDate().toString();
        const getStartYear = new Date(startDate).getFullYear();
        const getEndYear = new Date(endDate).getFullYear();
        const getStartMonth = new Date(startDate).getMonth();
        const getEndMonth = new Date(endDate).getMonth();

        let startDay = '', endDay = '', startMonth = '', endMonth = '', startYear = '', endYear = '';
        startDay = getStartDay;
        endDay = getEndDay;
        if (getStartYear === getEndYear) {
            startYear = getStartYear.toString();
        } else {
            startYear = getStartYear + '';
            endYear = getEndYear.toString();
        }
        if (getStartMonth === getEndMonth) {
            startMonth = T.t(_common.GetMonthText(getStartMonth));
        } else {
            startMonth = T.t(_common.GetMonthText(getStartMonth));
            endMonth = T.t(_common.GetMonthText(getEndMonth));
        }
        let result = startDay;
        result += (endMonth === '') ? '' : ' ' + startMonth;
        result += (endYear === '') ? '' : ' ' + startYear;
        result += '-' + endDay + ' ';
        result += (endMonth === '') ? startMonth + ' ' : ' ' + endMonth + ' ';
        result += (endYear === '') ? startYear + ' ' : ' ' + endYear + ' ';
        return result;
    }

    resetShowMore = (setActiveMenu?: boolean | null) => {
        if (!setActiveMenu) {
            this.props.dispatch(Actions.SetResetShowMoreCount(true));
        }
    }

    public weekOnClick = (event?: React.MouseEvent<HTMLDivElement>, itemKeyRef?: string, weekIdRef?: string, courseContentMenuType?: CourseContentMenuType, setActiveMenu?: boolean | null, disableFilter?: boolean | null) => {
        let eventWeekId = (event?.currentTarget.dataset.weekid) ? event.currentTarget.dataset.weekid.toString() : weekIdRef ?? ''
        let itemKey = (event?.currentTarget.dataset.itemkey) ? event.currentTarget.dataset.itemkey.toString() : itemKeyRef ?? '';
        let weekid = eventWeekId;
        if (this.props.courseDefaultView === CourseDefaultViewType.List) {
            this.props.closeModal();
        }
        this.setState({isFirstLoad: true})

        this.resetShowMore(setActiveMenu);

        if(this.props.courseDefaultView === CourseDefaultViewType.List)
        {
                this.setState({activeWeek: weekid})

        }
        //this.handleToggle(weekid);
        if (weekid && this.props.courseDefaultView === CourseDefaultViewType.List) {
            this.scrollToWeek(weekid);

        }
        ReactGA.event({
            category: window.location.host,
            action: 'G_WEEK_CLICKED',
            label: 'G_WEEK_CLICKED',
            nonInteraction: true,
        });
        this.setState({ activeCollapse: eventWeekId })

        let search = window.location.search;
        search = search.replace('?', '');
        const params = queryString.parse(search);


        if ((this.state.isFirstLoad || this.props.courseDefaultView === CourseDefaultViewType.Card)) {
            if (params.classId !== this.props.coursePageClassId!) {
                this.props.dispatch(Actions.SetTriggerWeekOnClick(itemKey,
                    this.props.coursePageclassInformation && (this.props.courseDefaultView === CourseDefaultViewType.List && this.state.weeklyTerm) ? '-1' : weekid,
                    this.props.courseContentMenuType!,
                    this.props.activeTabGuid!,
                    this.props.courseContentTermWeeks,
                    this.props.hasFilter,
                    this.props.coursePageClassId!,
                    this.props.coursePageActivityId!,
                    this.props.sort,
                    this.props.activityFilters,
                    this.props.courseContentWeeksActivities,
                    this.props.courseDefaultView,
                ));
            } else {
                this.props.dispatch(Actions.SetTriggerWeekOnClick(itemKey,
                    weekid,
                    this.props.courseContentMenuType!,
                    this.props.activeTabGuid!,
                    this.props.courseContentTermWeeks,
                    disableFilter === true ? false : this.props.hasFilter,
                    this.props.coursePageClassId,
                    this.props.coursePageActivityId!,
                    this.props.sort,
                    disableFilter === true ? this.state.filters : this.props.activityFilters,
                    this.props.courseContentWeeksActivities,
                    this.props.courseDefaultView,
                ));
            }
        }

        if (this.props.classId.courseDefaultView == CourseDefaultViewType.List && !this.state.listViewCalled) {
            this.props.dispatch(Actions.SetTriggerWeekOnClick(
                "",
                '-1',
                this.props.courseContentMenuType!,
                "",
                this.props.courseContentTermWeeks,
                this.props.hasFilter,
                this.props.coursePageClassId!,
                this.props.coursePageActivityId!,
                this.props.sort,
                this.props.activityFilters,
                this.props.courseContentWeeksActivities,
                this.props.courseDefaultView
            ));
            this.setState({ listViewCalled: true })
        }


    }
    public cancelMoveActivity = () => {
        const movementOptions = document.getElementsByClassName('movement_options');
        if (movementOptions) {
            for (let i = 0; i < movementOptions.length; i++) {
                movementOptions[i].classList.add('d-none');
            }
        }

        const movementButtons = document.getElementsByClassName('movement_buttons');
        if (movementButtons) {
            for (let i = 0; i < movementButtons.length; i++) {
                movementButtons[i].classList.add('d-none');
            }
        }
    };

    renderRedirect = () => {
        if (
            this.props.courseContentMenuType === CourseContentMenuType.week ||
            this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory
        ) {
            return (
                <Redirect to={`/almsp/u/course?classId=${this.props.coursePageClassId}&activityId=${this.props.coursePageActivityId}&type=1&weekorunitid=${this.state.actviteContextId}`} />
            );
        } else {
            return null;
        }
    };

    handleCollapse = (prevState: any) => {
        const node = this.collapseRef.current;
        if (this.state.activeCollapse === prevState.activeCollapse) {
            if (node) {
                if (this.state.isCollapseOpen && !prevState.isCollapseOpen) {
                    node.classList.remove('collapsing');
                    node.classList.add('collapse', 'show');

                } else if (!this.state.isCollapseOpen && prevState.isCollapseOpen) {
                    node.classList.remove('collapse', 'show');
                    node.classList.add('collapsing');
                }
            }
        } else if (this.state.isCollapseOpen && !prevState.isCollapseOpen && node) {
            node.classList.remove('collapsing');
            node.classList.add('collapse', 'show');
        }

    };

    handleToggle = (weekid: string) => {
        if (this.state.activeCollapse === weekid) {
            this.setState((prevState: any) => ({ isCollapseOpen: !prevState.isCollapseOpen }));

        } else {
            this.setState({ isCollapseOpen: false })
        }
    };

    countActivities = () => {
        let model = {
            completedActivityCounts: 0,
            activityCounts: 0
        };

        if (this.props.activityIdsByWeeks && this.props.activityIdsByWeeks.length > 0 && this.props.activityIdsByWeeks[0].activitiesByWeek) {
            if (this.props.activityIdsByWeeks && this.props.activityIdsByWeeks[0].notWeekly === true) {
                if (this.props.courseContentWeeksActivities) {
                    this.props.courseContentWeeksActivities.forEach(activity => {
                        model.activityCounts++;
                        this.returnCompletedActivityCount(activity, model.completedActivityCounts);
                    });
                }
            } else {
                this.props.activityIdsByWeeks.forEach((weeks: any) => {
                    weeks.activitiesByWeek.forEach((activity: any) => {
                        model.activityCounts++;
                        this.returnCompletedActivityCount(activity, model.completedActivityCounts);
                    });
                });
            }
        }
        return model
    }

    returnCompletedActivityCount = (activity: any, complatedActivityCounts: number) => {
        if (this.props.enrollmentData) {
            let filteredActivities = this.props.enrollmentData.filter(f => f.activityId === activity.activityId);
            let completedStatus = enrollmentStatus.NotStarted;
            if (filteredActivities.length > 0) {
                completedStatus = filteredActivities[0].status;
            }

            if (completedStatus === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
                complatedActivityCounts++;
            }
        } else {
            complatedActivityCounts = 0;
        }
        return complatedActivityCounts;
    }

    renderActivityCounts = (activityCounts: number, complatedActivityCounts: number) => {
        let content = null;
        if (activityCounts !== 0) {
            if (this.props.userType && this.props.userType === UserType.Student) {
                content = <Tooltip data={T.t('r_completed_all') + ": " + (complatedActivityCounts / activityCounts).toFixed(2)} position='left'>
                    {
                        !this.props.showMobile && <span className="active-border" tabIndex={0}>
                            <ProgressCircleLargeSidebar width={34} height={34} total={activityCounts} count={complatedActivityCounts} />
                        </span>
                    }
                </Tooltip>
            } else {
                content =

                    <Tooltip data={`${T.t('r_activity_count')}:${activityCounts}`} position={(document.body.getAttribute('dir') == 'rtl') ? 'right' : 'left'}>
                        {
                            !this.props.showMobile && <Badge pill={true} variant="light" style={{ backgroundColor: '#d9dadc', fontWeight: 600, fontSize: '10px', color: 'black', width: '20px' }}>
                                {activityCounts}
                            </Badge>
                        }
                    </Tooltip>

            }
        }
        return content;
    }

    renderLoading = (x: any) => {
        const loadingSpaces = 60;
        return (
            <Loading spinnerId={'getCourseContentsWeekActivitiesAction' + 'header' + x.itemGuid}>
                <div style={{ backgroundColor: '#eeede9' }}>
                    <ContentLoader
                        speed={2}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        viewBox="0 0 360 250"
                        style={{ width: '100%' }}
                        id='getCourseContentLoading'
                    >
                        <rect x="5" y="5" rx="5" ry="5" width="95" height="50" />
                        <rect x="105" y="5" rx="0" ry="0" width="250" height="50" />
                        <rect x="5" y={5 + loadingSpaces} rx="5" ry="5" width="95" height="50" />
                        <rect x="105" y={5 + loadingSpaces} rx="0" ry="0" width="250" height="50" />
                        <rect x="5" y={5 + loadingSpaces * 2} rx="5" ry="5" width="95" height="50" />
                        <rect x="105" y={5 + loadingSpaces * 2} rx="0" ry="0" width="250" height="50" />
                        <rect x="5" y={5 + loadingSpaces * 3} rx="5" ry="5" width="95" height="50" />
                        <rect x="105" y={5 + loadingSpaces * 3} rx="0" ry="0" width="250" height="50" />

                    </ContentLoader>
                </div>
            </Loading>
        )
    }

    renderCourseContentWeekActivities = (x: any, isCollapseOpen: boolean) => {
        let updatedClassName = isCollapseOpen ? ' show' : '';
        return (
            (!this.props.hasFilter && ((this.props.courseDefaultView !== CourseDefaultViewType.List) || !(this.state.weeklyTerm)) && (this.props.courseContentMenuType === CourseContentMenuType.weekAndActivity || this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory)) ?
                (
                    x.termWeekId === this.state.activeCollapse &&
                    <div className={!this.state.handleByManuel ? 'inner-items collapse show' : `inner-items collapse${updatedClassName}`} ref={this.collapseRef} key={x.itemGuid + 'collapse'} id={'collapse' + x.itemGuid} aria-labelledby={'header' + x.itemGuid} data-parent="#profileMainLoading_Content" style={{ width: "unset" }}>
                        {this.renderLoading(x)}
                        <div id={'getCourseContentsWeekActivitiesAction' + 'header' + x.itemGuid + '_Content'} style={{ width: "100%" }}>{
                            <CourseContentWeeksActivities showMobile={this.props.showMobile} closeModal={this.props.closeModal} showMenuById={x.itemGuid} isPassive={(x.startDate ?? '') > Moment().format('yyyy-MM-DDTHH:mm:ss') ? 1 : 0} />
                        }
                            <div className="movement_buttons d-none">
                                <a href="#" className="gray_button" onClick={this.cancelMoveActivity}>İptal Et</a>
                                <a href="#" className="green_button">Kaydet</a>
                            </div>
                        </div>
                    </div>

                ) : ('')
        )
    }

    returnCompletedIcon = (x: any) => {
        let icon;
        if (x.status === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
            icon = <div className="circle" style={{ width: 36, height: 36, marginLeft: '13px', marginRight: '5px' }}>
                <i className="material-icons icon-rtl" style={{ fontSize: 24, fontWeight: 'bold' }}>done</i>
            </div>
        } else {
            icon = <img src={_common.GetDefaultIcons('week')} style={{ width: '18px', margin: '9px 15px 9px' }} alt="icon" />
        }
        return icon;
    }

    returnWeekLabel = (x: any) => {
        const isPlanned = x.week !== 0 || (x.week === 0 && x.termId !== null);
        const weekText = x.week !== null && x.week !== undefined
            ? `${x.termType ?? T.t('r_time_week')} ${x.week}`
            : T.t('r_time_week');


        if (!isPlanned) {
            return <label>{T.t('r_gen_unplanned_activity')}</label>;
        }

        if (T.i18next.language === "ar") {
            return (
                <div className='col-md-9 d-flex flex-row-reverse justify-content-end'>
                    <label className="mr-1">{x.week}</label>
                    <label>{x.termType}</label>
                </div>
            );
        }

        return (
            <label style={{ cursor: 'pointer' }} tabIndex={0}>
                {weekText}
            </label>
        );
    };




    renderCourseContentWeeksList = (x: any, isCollapseOpen: boolean, activityCounts: number, complatedActivityCounts: number) => {
        let completedIcon = this.returnCompletedIcon(x);
        let weekLabel = this.returnWeekLabel(x);
        return (
            <li
                key={x.termWeekId}
                style={(x.startDate ?? '') > Moment().format('yyyy-MM-DDTHH:mm:ss') ? { opacity: 0.5, cursor: 'pointer' } : { cursor: 'pointer' }}
            >
                <div
                    onClick={(e: any) => this.weekOnClick(e)}
                    id={'id_' + x.itemGuid}
                    data-itemkey={'header' + x.itemGuid}
                    key={x.itemGuid}
                    data-weekid={x.termWeekId ?? '0'}
                    data-itemguid={x.itemGuid}
                    className="media course_week_header show"
                    style={{ height: '50px', margin: '-15px -10px' }}
                    onKeyDown={(event: any) => {
                        if (event.key === 'Enter') {
                            this.weekOnClick(event)
                        }
                    }}
                >
                    {completedIcon}
                    <div className="modal-body" style={{ margin: '9px 0px 9px' }}>
                        {
                            (x.notWeekly === true) ?
                                <>
                                    <label style={{ cursor: 'pointer', marginTop: "15px" }} tabIndex={0}>{T.t('r_activity_all')}</label>
                                    <span>&nbsp;</span>
                                </>
                                :
                                <div className='row align-items-center' style={{ marginTop: '0px', width: '250px' }}>
                                    <div className='col-10'>
                                        <div style={{ display: 'flex', gap: '2px' }}>
                                            {weekLabel}
                                            {/* {
                                                this.props.showMobile && <Badge pill={true} variant="light" style={{ backgroundColor: '#d9dadc', fontWeight: 600, fontSize: '10px', color: 'black', width: '20px' }} tabIndex={0}>
                                                    {activityCounts}
                                                </Badge>
                                            } */}
                                        </div>
                                        {x.startDate ? <span tabIndex={0}>{(x.startDate && x.endDate) ? this.getUiMonth(x.startDate, x.endDate) : ''}&nbsp;</span> : ''}
                                    </div>

                                    <div className='col-2'>
                                        <Badge pill={true} variant="light" style={{ backgroundColor: '#d9dadc', fontWeight: 600, fontSize: '10px', color: 'black', width: '20px' }} tabIndex={0}>
                                            {activityCounts}
                                        </Badge>
                                        {/* {this.renderActivityCounts(activityCounts, complatedActivityCounts)} */}
                                    </div>
                                </div>
                        }
                    </div>
                </div>
                {
                    this.renderCourseContentWeekActivities(x, isCollapseOpen)
                }
            </li>
        )
    }

    returnFilteredWeekContent = (x: any, isCollapseOpen: any, filteredWeek: any, activityCounts: number, complatedActivityCounts: any) => {

        if (filteredWeek && filteredWeek.length > 0) {
            let firstItem = filteredWeek[0];
            if (firstItem.activitiesByWeek) {
                firstItem.activitiesByWeek.forEach((activity: any) => {
                    activityCounts++;
                    complatedActivityCounts = this.returnCompletedActivityCount(activity, complatedActivityCounts);
                });
            }
        }
        let isUnplannedVisible = x.termWeekId !== '0' || activityCounts > 0
        if (isUnplannedVisible)
            return this.renderCourseContentWeeksList(x, isCollapseOpen, activityCounts, complatedActivityCounts)
    }

    renderWeeks = (isCollapseOpen: boolean, activityCounts: number, complatedActivityCounts: number) => {

        let filteredWeek: any = null;
        let content = null;
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 0) {
            content = this.props.courseContentTermWeeks.map((x: any, index) =>
            (
                (this.props.hasFilter && this.props.termWeeksOnFilter && this.props.termWeeksOnFilter.length && ((x.termWeekId && this.props.termWeeksOnFilter.indexOf(x.termWeekId) !== -1) || (!x.termWeekId && this.props.termWeeksOnFilter.indexOf('0') !== -1))) || !this.props.hasFilter || (this.props.termWeeksOnFilter && !this.props.termWeeksOnFilter.length) ? (
                    activityCounts = 0,
                    complatedActivityCounts = 0,
                    filteredWeek = this.props.activityIdsByWeeks?.filter((item: any) => item.termWeekId === x.termWeekId),
                    this.returnFilteredWeekContent(x, isCollapseOpen, filteredWeek, activityCounts, complatedActivityCounts)

                ) : ''
            ))
        } else {
            content = T.t('r_week_not_found') + '.';
        }
        return content;
    }

    renderMobileContentWeeks = (isCollapseOpen: boolean, activityCounts: number, complatedActivityCounts: number) => {
        return (
            <Modal
                isOpen={this.props.isOpenModalAdd}
                toggle={this.props.closeModal}
                modalClassName={'week-menu-modal modal-from-left slideInLeft show animated'}
                fade={true}
                style={{ display: this.props.modalVisible ? 'block' : 'none', animationDuration: '0.5s', margin: '0px', width: '85%', height: '100%' }}
                backdrop={'static'}
                id={'select-week'}
                size="lg"
            >

                <ModalBody style={{ margin: '0px', padding: '0px', height: '100vh' }}>
                    <div className="tab-content pt-0 animated fadeIn course_header_none" >
                        <div id="home" >
                            <div className="content-container" >

                                <div className="main-sidebar position-relative" style={{ flex: 1 }} >
                                    <div className='mobile-add-activity-button'><AddActivityButton /></div>
                                    {
                                        (this.props.courseContentMenuType) ?
                                            (
                                                <React.Fragment>
                                                    {
                                                        <button type="button" className="left-sidebar_close" >
                                                            <i aria-hidden="true" onClick={this.props.closeModal} className="material-icons" style={{ color: 'rgb(0, 0, 0)' }}>close</i>
                                                            <span>{T.t('r_fileUpload_cancel')}</span>
                                                        </button>
                                                    }
                                                    <ul id="profileMainLoading_Content" className={this.props.userType === UserType.Student ? 'content_week_height_student accordion-group' : 'content_week_height_teacher accordion-group'} style={{ scrollBehavior: 'smooth', backgroundColor: '#fbfaf6', position: 'relative', overflowX: 'hidden' }}>
                                                        {
                                                            this.renderWeeks(isCollapseOpen, activityCounts, complatedActivityCounts)
                                                        }
                                                    </ul>
                                                    {(this.state.redirect) ?
                                                        (
                                                            this.renderRedirect()
                                                        ) : ('')
                                                    }
                                                </React.Fragment>

                                            ) : ('')
                                    }

                                </div>
                                {this.props.userType === UserType.Student ?
                                    <div style={{ width: '100%', flex: 1, marginTop: '20px' }}>
                                        < ProgressPercent classId={this.props.coursePageClassId} userId={this.props.identity.userId} />
                                    </div>
                                    : ''}
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    renderWebContentWeeks = (isCollapseOpen: boolean, activityCounts: number, complatedActivityCounts: number) => {
        return (

            <React.Fragment>

                <ul id="profileMainLoading_Content" className={this.props.userType === UserType.Student ? 'content_week_height_student accordion-group' : 'content_week_height_teacher accordion-group'} style={{ scrollBehavior: 'smooth', backgroundColor: '#fbfaf6', position: 'relative', overflowX: 'hidden' }}>
                    {
                        this.renderWeeks(isCollapseOpen, activityCounts, complatedActivityCounts)
                    }
                </ul>
                {(this.state.redirect) ?
                    (
                        this.renderRedirect()
                    ) : ('')
                }
            </React.Fragment>

        );
    }

    public render() {
        const { isCollapseOpen } = this.state;
        let complatedActivityCounts: number = 0;
        let activityCounts: number = 0;
        let activityCountsModel = this.countActivities();

        complatedActivityCounts = activityCountsModel.completedActivityCounts;
        activityCounts = activityCountsModel.activityCounts;

        return (
            this.props.showMobile ? this.renderMobileContentWeeks(isCollapseOpen, activityCounts, complatedActivityCounts) :
                this.renderWebContentWeeks(isCollapseOpen, activityCounts, complatedActivityCounts)

        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICourseContentMenu): ICourseContentMenu => {
    if (!state) {
        return ownProps;
    }
    const newProps: ICourseContentMenu = Object.assign({}, ownProps, {
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        courseContentMenuLoading: state.coursePage.courseContentMenuLoading,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        activeTabGuid: state.coursePage.activeTabGuid,
        actId: state.coursePage.actId,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeekActivitiesLoading: state.coursePage.courseContentWeekActivitiesLoading,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        activityIdsByWeeks: state.coursePage.activityIdsByWeeks,
        userType: state.login.identitiy.userType,
        activityIdAfterAdd: state.coursePage.activityIdAfterAdd,
        deletedActivityId: state.coursePage.deletedActivityId,
        termWeeksOnFilter: state.coursePage.termWeeksOnFilter,
        activityFilters: state.coursePage.activityFilters,
        hasFilter: state.coursePage.hasFilter,
        enrollmentData: state.enrollment.enrollmentData,
        activityCard: state.coursePage.activityCard,
        sort: state.coursePage.courseSortingKey,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        courseDefaultView: state.coursePage.courseDefaultView,
        identity: state.login.identitiy,
        classId: state.coursePage.coursePageclassInformation,

    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.activeTabGuid === prev.coursePage.activeTabGuid &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.activityIdsByWeeks === prev.coursePage.activityIdsByWeeks &&
        next.coursePage.activityIdAfterAdd === prev.coursePage.activityIdAfterAdd &&
        next.coursePage.deletedActivityId === prev.coursePage.deletedActivityId &&
        next.coursePage.termWeeksOnFilter === prev.coursePage.termWeeksOnFilter &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.coursePage.hasFilter === prev.coursePage.hasFilter &&
        next.coursePage.coursePageclassInformation === prev.coursePage.coursePageclassInformation &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.login.identitiy === prev.login.identitiy
    );
    return ret;
};

const CCourseContentWeeks = connect(
    mapStateToProps,
    dispatchProps, null, {
    areStatesEqual
}
)(CourseContentWeeks);

export default CCourseContentWeeks;
